import React from "react";
import { TextFilter } from "@design-system";

export const filterTitle = ({
  setSelectedKeys,
  confirm,
  clearFilters,
  defaultValue,
}: {
  setSelectedKeys: (selectedKeys: string) => void;
  confirm: () => void;
  clearFilters?: () => void;
  defaultValue?: string | undefined;
}) => (
  <TextFilter
    defaultValue={defaultValue}
    onApplyFilter={(value) => {
      setSelectedKeys(value);
      confirm();
    }}
    onClearFilter={() => {
      clearFilters && clearFilters();
      confirm();
    }}
  />
);
